
import { Component, namespace, Vue } from 'nuxt-property-decorator'
import { ActionType, namespace as quizNamespace, QuizCompletedQuestion } from '~/store/modules/Quiz'
import { QuestionID, QuizAnswer, QuizQuestion } from '~/core/config/comparator/quiz/interfaces/types'
import QuizProgressBar from '~/components/pages/quiz/QuizProgressBar/QuizProgressBar.vue'
import { getExternalCompareMobileHref, getExternalCompareHomeHref } from '~/utils/external-links.utils'
import QuizGrid from '~/components/pages/quiz/QuizGrid'
import QuizGridItem from '~/components/pages/quiz/QuizGridItem'
import { OnCreated } from '~/core/vue.types'

const QuizStore = namespace(quizNamespace)

@Component({
  components: {
    QuizProgressBar,
    QuizGrid,
    QuizGridItem,
  },
})
export default class QuizForm extends Vue implements OnCreated {
  @QuizStore.Getter('getCurrentQuestion')
  readonly currentQuestion!: QuizQuestion

  @QuizStore.Getter('getCurrentQuestionNumber')
  readonly currentQuestionNumber!: number

  @QuizStore.Getter('getMaxQuestionsCount')
  readonly maxQuestionsCount!: number

  @QuizStore.Getter('getCompletedQuestionsStack')
  readonly completedQuestionsStack!: QuizCompletedQuestion[]

  @QuizStore.Getter('getQuestionById')
  getQuestionById!: (id: QuestionID) => QuizQuestion

  @QuizStore.Action(ActionType.COMPLETE_QUESTION)
  setAnswer!: (payload: QuizCompletedQuestion) => void

  @QuizStore.Action(ActionType.INIT)
  initState!: () => Promise<void>

  private isLockedState = false

  get isSkippable () {
    const { query } = this.$router.currentRoute
    return query?.qq
  }

  skipQuiz () {
    const { query } = this.$router.currentRoute
    // check first answer - "Choose your plan"
    switch (query.qa[0]) {
      case '1':
        window.open(getExternalCompareMobileHref(this.$config.BASE_URL, this.localePath))
        break
      case '2':
        window.open(getExternalCompareHomeHref(this.$config.BASE_URL, this.localePath))
        break
      case '3':
        this.$router.push(this.localePath('compare-bundle'))
        break
    }
  }

  onQuizItemClick (answer: QuizAnswer) {
    this.isLockedState = true

    this.setAnswer({
      answerId: answer.id,
      questionId: this.currentQuestion.id,
      nextQuestionId: answer.nextQuestionId,
    })
  }

  async created () {
    await this.initState()
  }
}
